import React from "react";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import { Avatar } from "@mui/material";

export default function InfoCard({ job }) {
  const color = job.color || "#333";

  return (
    <>
      <Card
        sx={{
          minWidth: "175px",
          borderRadius: "24px",
          backgroundColor: color,
          borderWidth: 0,
        }}
      >
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              gap: "1.5rem",
            }}
          >
            <div>
              <Avatar
                src={job.logo}
                alt={`${job.company} logo`}
                sx={{ width: 56, height: 56, mb: 2, backgroundColor: "#FFF" }}
              />
              <Typography level="title-md" textColor="#FEFEFE">
                {job.company}
              </Typography>
            </div>

            <div>
              <Typography level="title-lg" textColor="#FFF">
                  {job.position}
                </Typography>
              </div>

            <div>
              <Typography level="body-sm" textColor="#FEFEFE">
                {job.dates}
              </Typography>
              <Typography level="title-sm" textColor="#FFF">
                {job.location}
              </Typography>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}